export default __webpack_public_path__ + "static/media/logo.0bd7d4f8.svg";